import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router, RouterModule } from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})

export class BreadcrumbComponent {

  public breadcrumbs: { parentBreadcrumb?: string; childBreadcrumb?: string; enable?: boolean };
  public title: string = '';

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private auth: AuthService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe(route => {
        let title = route.snapshot.data['title'];
        let parent = route.parent?.snapshot.data['breadcrumb'];
        let child = route.snapshot.data['breadcrumb'];
        
        // Dinámicamente asignar el título del breadcrumb principal
        let overrideTitle = parent;
        if (parent === 'Cotizar/Reservar' || parent === 'Logística') {
          let permissions = this.auth.getPermissions() ?? [];
          if (permissions.includes('rol_client') && !permissions.includes('Lista')) {
            overrideTitle = 'Cotizar/Reservar';
          } else {
            overrideTitle = 'Logística';
          }
          parent = overrideTitle;
          if (title === 'Cotizar/Reservar' || title === 'Logística') {
            title = overrideTitle;
          }
        }

        this.breadcrumbs = {};
        this.title = title;
        this.breadcrumbs = {
          "parentBreadcrumb": parent,
          "childBreadcrumb": child,
        }
      });
  }

}
